import { render, staticRenderFns } from "./LazyVideo.vue?vue&type=template&id=5ddb51d0&scoped=true"
import script from "./LazyVideo.vue?vue&type=script&lang=js"
export * from "./LazyVideo.vue?vue&type=script&lang=js"
import style0 from "./LazyVideo.vue?vue&type=style&index=0&id=5ddb51d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddb51d0",
  null
  
)

export default component.exports